import React, { FunctionComponent, useEffect, useState } from 'react';
import { Input } from 'antd';

interface Props {
  value?: string;

  isValid?(value: string): boolean;

  onChange?(value: string): void;
}

export const TextInput: FunctionComponent<Props> = ({ isValid, ...props }) => {
  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if ((props.value || props.value === '') && props.onChange && value === undefined) {
      setValue(props.value);
      props.onChange(props.value);
    }
  }, [props.value]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isValid) {
      if (isValid(e.target.value)) {
        if (props.onChange) {
          props.onChange(e.target.value);
        }
        setValue(e.target.value);
      }
    } else {
      if (props.onChange) {
        props.onChange(e.target.value);
      }
      setValue(e.target.value);
    }
  };

  return <Input {...props} onChange={onChange} value={value} />;
};
